import * as yup from 'yup';

import { PackageStatus } from 'common/contracts';
import { ChipStatus } from 'components/Chip/Chip';

export const statusMapping: Record<PackageStatus, ChipStatus> = {
  [PackageStatus.ACTIVE]: 'danger',
  [PackageStatus.INACTIVE]: 'secondary',
  [PackageStatus.TESTING]: 'warning',
  [PackageStatus.GRADUAL_RELEASE]: 'success',
  [PackageStatus.READY]: 'active'
};

export const newPackageFormSchema = yup.object().shape({
  versionName: yup
    .string()
    .matches(/^\d+\.\d+\.\d+$/, 'version name must match the format X.X.X')
    .required('Version name is required')
    .min(1, 'version name must not be empty'),
  versionCode: yup
    .string()
    .required('Version code is required')
    .min(1, 'version code must not be empty'),
  packageName: yup
    .string()
    .required('Package name is required')
    .min(1, 'package name must not be empty'),
  errorRedirectUrl: yup
    .string()
    .required('Error redirect URL is required')
    .min(1, 'Error redirect URL must not be empty')
    .url('Error redirect URL must be a valid URL')
});
